import React, { Component } from 'react';
import{
    Dialog
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import i18n from '../../i18n'

class DialogBox extends Component{

    constructor(props){
        super(props);
        this.state = {
            selectedImgId:0,
            ImgMount:0
        }
    }

    //ボタンで同じ日付の画像をスウィッチ
    change=()=>{
        var target = window.event.target
        var id = parseInt(target.getAttribute("id")) //buttonのidを取得
        this.props.changeIndex(id)
        this.setState({
            selectedImgId: id
        })
    }

    closeDialog=()=>{
        this.setState({
            selectedImgId: 0
        })
        this.props.closeDialog()
    }

    back=()=>{
        var ImgMount = this.props.data[0].encodevalue.length
        if(this.state.selectedImgId - 1 >= 0){
            var id = this.state.selectedImgId - 1
            this.setState({
                selectedImgId: id
            })
            this.props.changeIndex(id)
        }else{
            var id = ImgMount - 1
            this.setState({
                selectedImgId: id
            })
            this.props.changeIndex(id)
        }
    }

    forward=()=>{
        var ImgMount = this.props.data[0].encodevalue.length
        if(this.state.selectedImgId + 1 < ImgMount){
            var id = this.state.selectedImgId + 1
            this.setState({
                selectedImgId: id
            })
            this.props.changeIndex(id)
        }else{
            var id = 0
            this.setState({
                selectedImgId: id
            })
            this.props.changeIndex(id)
        }
    }

    render(){

        const data = this.props.data
        var mapURL = "https://www.google.com/maps/search/?api=1&query=" + data[0].address

        var buttons = []
        var imgs = []
        var index = 0

        if(typeof data[0].encodevalue === "string"){
            buttons.push(
                <button key={index} id={0} style={styles.buttonBlack} onClick={this.change}></button>
            )
            imgs.push(
                <img 
                    src={data[0].encodevalue} 
                    key={index}
                    style={styles.img}>
                </img>
            )
            index++
        }else if(typeof data[0].encodevalue === "object"){
            for(let i = 0; i < data[0].encodevalue.length; i++){
                if(this.props.buttonIndex == i){
                    buttons.push(
                        <button key={i} id={i} style={styles.buttonBlack} onClick={this.change}></button>
                    )
                }else{
                    buttons.push(
                        <button key={i} id={i} style={styles.buttonGray} onClick={this.change}></button>
                    )
                }
            }
            imgs.push(
                <img 
                    src={data[0].encodevalue[this.props.buttonIndex]} 
                    key={index}
                    style={styles.img}
                >
                </img>
            )
            var ImgMount = this.props.data[0].encodevalue.length
            if(ImgMount > 1){
                imgs.push(
                    <div key="arrow">
                        <ArrowForwardIosIcon
                            style={styles.ArrowForwardIosIcon}
                            onClick={this.forward}  
                        />
                        <ArrowBackIosIcon
                            style={styles.ArrowBackIosIcon} 
                            onClick={this.back}  
                        />
                    </div>
                )
            }
        }

        return(
            <div>
                <Dialog maxWidth onClose={this.closeDialog} open={this.props.open}>
                    <ClearIcon
                        style={styles.clearIcon}
                        onClick={this.closeDialog}
                    /> 
                    <div className={"imgArea"} style={{textAlign:"center", marginTop:"40px"}}>
                        {imgs}
                    </div>
                    <div className={"buttomArea"} style={{textAlign:"center", margin:"5px 0"}}>
                        {buttons}
                    </div>
                    <p style={styles.p}>{i18n.t('flows.dialogBox.date')}{data[0].timestamp}</p> 
                    <p style={styles.p}>{i18n.t('flows.dialogBox.address')}{data[0].address}</p>
                    <p style={styles.p}>＞＞<a target="view_window" href={mapURL}>{i18n.t('flows.dialogBox.map')}</a>{i18n.t('flows.dialogBox.showed_by')}</p>
                </Dialog>
            </div>
        )   
    }
}

// ウィンドウの縦幅と横幅
var windowHeight = window.innerHeight
var windowWidth = window.innerWidth
//画像のマックス縦幅縦幅と横幅
var maxHeight = 0.81 * windowHeight + "px"
var maxWidth = 0.85 * windowWidth + "px"
//画像の位置（レスポンシブ）
var paddingTop = 0
var paddingLeft = 0
if(windowWidth <= 1024){　//スマホまたはタブレットの場合
    paddingTop = 0.02 * windowHeight + "px"
    paddingLeft = 0.05 * windowWidth + "px"
}else{　//PCの場合
    paddingTop = 0.02 * windowHeight + "px"
    paddingLeft = 0.03 * windowWidth + "px"
}
var padding = paddingTop + " " + paddingLeft

const styles = {
    p:{
        fontSize:"30px",
        paddingLeft:paddingLeft,
        paddingRight:paddingLeft
    },
    buttonBlack:{
        height:"25px",
        width:"25px",
        borderRadius:"15px", 
        marginRight:"10px",
        outline:"none",
        background:"black"
    },
    buttonGray:{
        height:"25px",
        width:"25px",
        borderRadius:"15px", 
        marginRight:"10px",
        outline:"none",
    },
    img:{
        padding:padding, 
        maxHeight:maxHeight, 
        maxWidth:maxWidth, 
        width:"auto"
    },
    clearIcon:{
        fontSize:"50px", 
        position:"absolute",
        right:"1%", 
        marginTop:"10px",
        cursor: "pointer"
    },
    ArrowBackIosIcon:{
        fontSize:"120px",
        position:"fixed",
        top:"45%",
        left:"20px",
        color:"white"
    },
    ArrowForwardIosIcon:{
        fontSize:"120px",
        position:"fixed",
        top:"45%",
        right:"-10px",
        color:"white"
    }
}

export default DialogBox;